import { addMutator } from '@poa/state';

import {
  fetchUser,
  fetchUserFailed,
  fetchUserSuccess,
  updateUserSuccess,
  createUser,
  createUserSuccess,
  createUserFailed
} from './users.actions';

// fetch
addMutator(fetchUser, (payload, { store }) => {
  store.users.meta.isLoading = true;
  store.users.meta.hasError = false;
});

addMutator(fetchUserSuccess, ({ data, id }, { store }) => {
  store.users.meta.isLoading = false;
  store.users.meta.hasError = false;
  store.users.data.push(data);
});

addMutator(fetchUserFailed, (payload, { store }) => {
  store.users.meta.isLoading = false;
  store.users.meta.hasError = true;
});

// create
addMutator(createUser, (payload, { store }) => {});
addMutator(createUserSuccess, (payload, { store }) => {});
addMutator(createUserFailed, (payload, { store }) => {});

// update
addMutator(updateUserSuccess, (payload, { store }) => {
  const user = store.users.data.find(user => user.id === payload.user.id);

  if (user) {
    Object.assign(user, payload.user);
  }
});
